import { logger } from '@/lib/telemetry/logger';

export const fundingLimitStorage = {
  get(key: string): string | null {
    try {
      return typeof window === 'undefined' ? null : window.localStorage.getItem(key);
    } catch {
      logger.warn('onramp.limit_display_cache_unavailable', { action: 'read' });
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      logger.warn('onramp.limit_display_cache_unavailable', { action: 'write' });
    }
  },
};
